import React from 'react'

import PowerpointBuilder from './PowerpointBuilder'
import PowerpointBuilderStore from './Powerpointbuilderstore'

export default class PPBuilder extends React.Component {
    constructor(props) {
        super(props)

        const { store } = props

        this.builderStore = new PowerpointBuilderStore(store)

        window.addEventListener('keydown', (e) => {
            if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
                e.preventDefault()
            }

            switch (e.key) {
                case 'ArrowUp':
                    this.builderStore.handleKeyboardListener(-1)
                    break
                case 'ArrowDown':
                    this.builderStore.handleKeyboardListener(1)
                    break
                default:
                    break
            }
        })
    }

    render() {
        return <PowerpointBuilder store={this.builderStore} />
    }
}
